module.exports = __webpack_public_path__ + "img/payImg.b7466ac9.jpg";